import { Injectable } from '@angular/core';
import { DataRoomProxy } from '../../proxy/offering/data-room.proxy';

@Injectable()
export class DataRoomService {

    constructor(private dataRoomProxy: DataRoomProxy) {

    }

    GetDataRoomCards(typeId: string) {
        return this.dataRoomProxy.GetDataRoomCards(typeId);
    }

    GetDataRoomCarousels(typeId: string) {
        return this.dataRoomProxy.GetDataRoomCarousels(typeId);
    }

    GetDataRoomCommonFields() {
        return this.dataRoomProxy.GetDataRoomCommonFields();
    }
}